import React, { useState } from "react";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { createUser } from "slices/systemAdmin/actions/users";
import { createUserAndAddToWorkspace } from "slices/userAdmin/actions/userAdmin";
import Field, { fieldTypes } from "components/Field";
import Checkbox, {
  checkboxStates,
} from "@visiblethread/react-components/dist/components/Checkbox";

const NewUserModal = () => {
  const dispatch = useDispatch();

  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [systemAdmin, setSystemAdmin] = useState(false);

  const [userNameError, setUserNameError] = useState("");
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const isUserNamePassword = useSelector(
    (state) => state?.systemAdmin.isUsernamePassword
  );

  const ssoButtonEnabled = () =>
    userName &&
    firstName &&
    lastName &&
    userNameError === "" &&
    firstNameError === false &&
    lastNameError === false;

  const userPassButtonEnabled = () =>
    userName &&
    firstName &&
    lastName &&
    password &&
    confirmPassword &&
    userNameError === "" &&
    firstNameError === false &&
    lastNameError === false &&
    passwordError === "" &&
    confirmPasswordError === "" &&
    password === confirmPassword;

  const isButtonEnabled = () =>
    isUserNamePassword ? userPassButtonEnabled() : ssoButtonEnabled();

  const isInSystemAdminPage = window.location.pathname.includes("systemAdmin");

  const handleCreate = () => {
    if (isInSystemAdminPage) {
      dispatch(
        createUser(
          userName?.trim(),
          firstName?.trim(),
          lastName?.trim(),
          password?.trim(),
          systemAdmin
        )
      );
    } else {
      dispatch(
        createUserAndAddToWorkspace(
          userName?.trim(),
          firstName?.trim(),
          lastName?.trim(),
          password?.trim()
        )
      );
    }
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter" && isButtonEnabled()) {
      handleCreate();
    }
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.NEW_USER));
  };

  const adminCheckbox = () => (
    <div className="new__user__modal__admin">
      <span>
        <b>System Administrator</b>
      </span>
      <Checkbox
        state={systemAdmin ? checkboxStates.checked : checkboxStates.empty}
        handleChange={() => {
          setSystemAdmin(!systemAdmin);
        }}
        disabled={false}
        id="cb-new-user-system-admin"
        value="new-user-system-admin-checkbox"
      />
    </div>
  );

  return (
    <Modal
      data-testid="newUserModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header closeButton>
        <b className="new__user__modal__header">Add User</b>
      </Modal.Header>
      <Modal.Body>
        <div className="new__user__modal">
          <Field
            type={fieldTypes.userName}
            propsObject={{
              userName,
              setUserName,
              userNameError,
              setUserNameError,
            }}
          />
          <Field
            type={fieldTypes.firstName}
            propsObject={{
              firstName,
              setFirstName,
              firstNameError,
              setFirstNameError,
            }}
          />
          <Field
            type={fieldTypes.lastName}
            propsObject={{
              lastName,
              setLastName,
              lastNameError,
              setLastNameError,
            }}
          />
          {(isUserNamePassword || systemAdmin) && (
            <Field
              type={fieldTypes.passwordAndConfirm}
              propsObject={{
                password,
                setPassword,
                passwordError,
                setPasswordError,
                confirmPassword,
                setConfirmPassword,
                confirmPasswordError,
                setConfirmPasswordError,
              }}
            />
          )}
          {isInSystemAdminPage && adminCheckbox()}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          dataTestId="saveButton"
          variant={buttonVariants.primary}
          onClick={handleCreate}
          disabled={!isButtonEnabled()}
          content="Add User"
        />
        <Button
          dataTestId="cancelButton"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default NewUserModal;
